
import React, { useEffect, useRef } from 'react';
import './LoginSignupForm.css';

function LoginPage() {
  const containerRef = useRef(null);
  const registerBtnRef = useRef(null);
  const loginBtnRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    const registerBtn = registerBtnRef.current;
    const loginBtn = loginBtnRef.current;

    registerBtn.addEventListener('click', () => {
      container.classList.add('active');
    });

    loginBtn.addEventListener('click', () => {
      container.classList.remove('active');
    });

    // Clean up event listeners on unmount
    return () => {
      registerBtn.removeEventListener('click', () => {
        container.classList.add('active');
      });

      loginBtn.removeEventListener('click', () => {
        container.classList.remove('active');
      });
    };
  }, []);

  return (
    <div className='login-page'>
    <div className="container" id="container" ref={containerRef}>
      <div className="form-container sign-up">
        <form>
          <h2>Create Account</h2>
          <input type="text" placeholder="Name" />
          <input type="email" placeholder="Email" />
          <input type="Text" placeholder="Contact Number" />
          <input type="password" placeholder="Password" />
          <input type="password" placeholder="Conform password" />
          <button>Sign Up</button>
        </form>
      </div>
      <div className="form-container sign-in">
        <form>
          <h1>Sign In</h1>
          <input type="email" placeholder="Email" />
          <input type="password" placeholder="Password" />
          <a href="#l">Forgot your email or password?</a>
          <button>Sign in</button>
        </form>
      </div>
      <div className="toggle-container">
        <div className="toggle">
          <div className="toggle-panel toggle-left">
            <h1>Vedhaa</h1>
            <p>Enter your personal details to use all of site features</p>
            <button className="hidden" id="login" ref={loginBtnRef}>Sign In</button>
          </div>
          <div className="toggle-panel toggle-right">
            <h1>Hello, User!</h1>
            <p>Register with your personal details to use all of site features</p>
            <button className="hidden" id="register" ref={registerBtnRef}>Sign Up</button>
          </div>
        </div>
      </div>
    </div>
    </div>
  );
}

export default LoginPage;

